module.exports = __webpack_public_path__ + "static/media/logo-branca.df6d8b4f.svg";